module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Failed Invoicing\n        ")]), _vm._v(" "), [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columnTableInvoice,
      "data": _vm.itemInvoice
    }
  })]], 2), _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-ok": _vm.updateIsActive
    },
    model: {
      value: (_vm.modal.editItemInvoice),
      callback: function($$v) {
        _vm.$set(_vm.modal, "editItemInvoice", $$v)
      },
      expression: "modal.editItemInvoice"
    }
  }, [_c('Form', {
    ref: "formeditItemInvoice",
    attrs: {
      "model": _vm.formeditItemInvoice
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "placeholder": "Invoice ID"
    },
    model: {
      value: (_vm.formeditItemInvoice.id),
      callback: function($$v) {
        _vm.$set(_vm.formeditItemInvoice, "id", $$v)
      },
      expression: "formeditItemInvoice.id"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Re-Invoicing")])], 1), _vm._v(" "), _c('p', [_vm._v("Anda yakin ingin Re-Invoicing Invoice ID : " + _vm._s(this.formeditItemInvoice.id) + " ?")])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ffb1ff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/FailedInvoicing.vue
// module id = 1791
// module chunks = 1